export enum RabotStrategyTypeEnum {
  LP = 'LP',
  STAKING = 'STAKING',
}
